<template>
  <v-card
    class="modern-card laudos-system"
    min-width="1200"
  >
    <!-- Cabeçalho com informações do paciente -->
    <div
      v-if="dadosPaciente"
      class="patient-header"
    >
      <v-card
        variant="outlined"
        class="modern-card header-card"
      >
        <v-row
          align="center"
          class="pa-4"
        >
          <!-- Coluna 1: Avatar e Nome -->
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <div class="patient-identity">
              <v-avatar
                size="64"
                color="primary"
                class="patient-avatar"
              >
                <span class="white--text text-h6 font-weight-bold">
                  {{ getIniciais(dadosPaciente.paciente) }}
                </span>
              </v-avatar>
              <div class="patient-info">
                <h3 class="patient-name">
                  {{ dadosPaciente.paciente }}
                </h3>
                <v-chip
                  color="primary"
                  variant="flat"
                  size="small"
                  class="status-chip"
                >
                  <span class="material-icons icon-sm">local_offer</span>
                  {{ dadosPaciente.atendimento }}
                </v-chip>
              </div>
            </div>
          </v-col>

          <!-- Coluna 2: Dados Pessoais -->
          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <div class="info-section">
              <div class="info-item">
                <span class="material-icons info-icon">cake</span>
                <div class="info-content">
                  <div class="info-label">
                    Nascimento
                  </div>
                  <div class="info-value">
                    {{ dadosPaciente.dataNascimento }}
                  </div>
                </div>
              </div>
              <div class="info-item">
                <span class="material-icons info-icon">calendar_today</span>
                <div class="info-content">
                  <div class="info-label">
                    Idade
                  </div>
                  <div class="info-value">
                    {{ dadosPaciente.idade }} anos
                  </div>
                </div>
              </div>
              <div class="info-item">
                <span class="material-icons info-icon">female</span>
                <div class="info-content">
                  <div class="info-label">
                    Sexo
                  </div>
                  <div class="info-value">
                    {{ dadosPaciente.sexo }}
                  </div>
                </div>
              </div>
            </div>
          </v-col>

          <!-- Coluna 3: Dados Adicionais -->
          <v-col
            cols="12"
            sm="12"
            md="4"
          >
            <div class="info-section">
              <div class="info-item">
                <span class="material-icons info-icon">location_on</span>
                <div class="info-content">
                  <div class="info-label">
                    Cidade
                  </div>
                  <div class="info-value">
                    {{ dadosPaciente.cidade }}
                  </div>
                </div>
              </div>
              <div class="info-item">
                <span class="material-icons info-icon">local_hospital</span>
                <div class="info-content">
                  <div class="info-label">
                    Convênio
                  </div>
                  <div class="info-value">
                    {{ dadosPaciente.convenio }}
                  </div>
                </div>
              </div>
              <div class="info-item">
                <span class="material-icons info-icon">medical_services</span>
                <div class="info-content">
                  <div class="info-label">
                    Solicitante
                  </div>
                  <div class="info-value">
                    {{ dadosPaciente.solicitante }}
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <!-- Tabs Principais -->
    <v-tabs 
      v-model="activeTab" 
      class="modern-tabs wide-tabs main-tabs" 
      color="primary"
      align-tabs="center"
    >
      <v-tab
        value="laudos"
        class="modern-tab wide-tab"
      >
        <div class="tab-content wide-tab-content">
          <div class="icon-badge-container">
            <span class="material-icons tab-icon">description</span>
            <v-badge
              :content="laudosAbertos.length"
              color="error"
              class="icon-badge"
              overlap
            />
          </div>
          <div class="tab-text-content">
            <span class="tab-label">Gerenciar Laudos</span>
          </div>
        </div>
      </v-tab>

      <v-tab
        value="editor"
        class="modern-tab wide-tab"
        :disabled="!selectedLaudo"
      >
        <div class="tab-content wide-tab-content">
          <div class="icon-badge-container">
            <span class="material-icons tab-icon">edit_note</span>
            <v-badge
              v-if="temAlteracoesNaoSalvas"
              content="!"
              color="warning"
              class="icon-badge"
              overlap
            />
          </div>
          <div class="tab-text-content">
            <span class="tab-label">Editor de Laudo</span>
            <div
              v-if="selectedLaudo"
              class="priority-indicator"
            >
              Editando
            </div>
          </div>
        </div>
      </v-tab>
    </v-tabs>

    <v-divider />

    <!-- Conteúdo Principal -->
    <v-window
      v-model="activeTab"
      class="modern-window main-window"
    >
      <!-- Aba: Gerenciar Laudos -->
      <v-window-item value="laudos">
        <div class="tab-content-wrapper">
          <!-- Filtros e Controles -->
          <div class="controls-section">
            <v-tabs
              v-model="laudoTab"
              class="modern-tabs sub-tabs"
              color="primary"
            >
              <v-tab
                value="abertos"
                class="modern-tab"
              >
                <div class="tab-content">
                  <span class="material-icons tab-icon">pending</span>
                  <span class="tab-label">Laudos Abertos</span>
                  <v-badge 
                    v-if="laudosAbertos.length > 0"
                    :content="laudosAbertos.length"
                    color="warning"
                    class="icon-badge"
                    floating
                  />
                </div>
              </v-tab>
              <v-tab
                value="liberados"
                class="modern-tab"
              >
                <div class="tab-content">
                  <span class="material-icons tab-icon">check_circle</span>
                  <span class="tab-label">Laudos Liberados</span>
                  <v-badge 
                    v-if="laudosLiberados.length > 0"
                    :content="laudosLiberados.length"
                    color="success"
                    class="icon-badge"
                    floating
                  />
                </div>
              </v-tab>
            </v-tabs>

            <v-text-field
              v-model="buscaAtual"
              :placeholder="`Buscar em ${laudoTab === 'liberados' ? 'Laudos Liberados' : 'Laudos Abertos'}...`"
              variant="outlined"
              density="compact"
              class="search-field"
              prepend-inner-icon="search"
              clearable
              hide-details
            />
          </div>

          <!-- Lista de Laudos -->
          <div class="content-area">
            <v-window v-model="laudoTab">
              <!-- Laudos Abertos -->
              <v-window-item value="abertos">
                <div
                  v-if="laudosAbertosFiltrados.length > 0"
                  class="patient-list tall-list"
                >
                  <v-card 
                    v-for="(laudo, index) in laudosAbertosFiltrados" 
                    :key="'aberto-' + index"
                    class="patient-item laudo-card"
                    :class="{ 'selected': selectedLaudo?.idLaudo === laudo.idLaudo }"
                    variant="outlined"
                    @click="selectLaudo(laudo)"
                  >
                    <v-card-item>
                      <div class="laudo-item">
                        <v-avatar
                          color="warning"
                          variant="flat"
                          size="48"
                          class="mr-3"
                        >
                          <span class="material-icons white--text">pending</span>
                        </v-avatar>
                        <div class="laudo-content">
                          <div class="laudo-header">
                            <h4 class="laudo-title">
                              {{ laudo.apelidoExame }}
                            </h4>
                            <v-chip
                              color="warning"
                              variant="flat"
                              size="small"
                              class="status-chip"
                            >
                              Pendente
                            </v-chip>
                          </div>
                          <div class="laudo-details">
                            <div class="detail-item">
                              <span class="material-icons detail-icon">person</span>
                              <span>{{ laudo.nomePaciente }}</span>
                            </div>
                            <div class="detail-item">
                              <span class="material-icons detail-icon">event</span>
                              <span>{{ formatDate(laudo.dataRegistro) }}</span>
                            </div>
                            <div
                              v-if="laudo.obsLaudoTec"
                              class="detail-item"
                            >
                              <span class="material-icons detail-icon">note</span>
                              <span class="text-truncate">{{ laudo.obsLaudoTec }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card-item>
                  </v-card>
                </div>
                <div
                  v-else
                  class="empty-state"
                >
                  <span class="material-icons empty-icon">inventory_2</span>
                  <div class="empty-text">
                    Nenhum Laudo Pendente
                  </div>
                </div>
              </v-window-item>

              <!-- Laudos Liberados -->
              <v-window-item value="liberados">
                <div
                  v-if="laudosLiberadosFiltrados.length > 0"
                  class="patient-list tall-list"
                >
                  <v-card 
                    v-for="(laudo, index) in laudosLiberadosFiltrados" 
                    :key="'liberado-' + index"
                    class="patient-item laudo-card"
                    :class="{ 'selected': selectedLaudo?.idLaudo === laudo.idLaudo }"
                    variant="outlined"
                    @click="selectLaudo(laudo)"
                  >
                    <v-card-item>
                      <div class="laudo-item">
                        <v-avatar
                          color="success"
                          variant="flat"
                          size="48"
                          class="mr-3"
                        >
                          <span class="material-icons white--text">check_circle</span>
                        </v-avatar>
                        <div class="laudo-content">
                          <div class="laudo-header">
                            <h4 class="laudo-title">
                              {{ laudo.apelidoExame }}
                            </h4>
                            <v-chip
                              color="success"
                              variant="flat"
                              size="small"
                              class="status-chip"
                            >
                              Liberado
                            </v-chip>
                          </div>
                          <div class="laudo-details">
                            <div class="detail-item">
                              <span class="material-icons detail-icon">person</span>
                              <span>{{ laudo.nomePaciente }}</span>
                            </div>
                            <div class="detail-item">
                              <span class="material-icons detail-icon">event</span>
                              <span>{{ formatDate(laudo.dataRegistro) }}</span>
                            </div>
                            <div
                              v-if="laudo.obsLaudoTec"
                              class="detail-item"
                            >
                              <span class="material-icons detail-icon">note</span>
                              <span class="text-truncate">{{ laudo.obsLaudoTec }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card-item>
                  </v-card>
                </div>
                <div
                  v-else
                  class="empty-state"
                >
                  <span class="material-icons empty-icon">checklist</span>
                  <div class="empty-text">
                    Nenhum Laudo Liberado
                  </div>
                </div>
              </v-window-item>
            </v-window>
          </div>
        </div>
      </v-window-item>

      <!-- Aba: Editor de Laudo -->
      <v-window-item value="editor">
        <div class="tab-content-wrapper">
          <div
            v-if="selectedLaudo"
            class="editor-container"
          >
            <v-row>
              <v-col
                cols="12"
                md="8"
              >
                <v-card
                  class="modern-card editor-card"
                  variant="outlined"
                >
                  <v-card-item class="editor-header">
                    <div class="editor-title">
                      <span class="material-icons tab-icon">edit_note</span>
                      Editor de Laudo - {{ selectedLaudo.nomeExame }}
                    </div>
                    <v-spacer />
                    <div class="editor-actions">
                      <v-btn 
                        color="primary" 
                        variant="flat" 
                        size="small"
                        :loading="salvando"
                        class="action-btn"
                        @click="salvarLaudo"
                      >
                        <span class="material-icons">save</span>
                        Salvar
                      </v-btn>
                      <v-btn 
                        color="secondary" 
                        variant="outlined" 
                        size="small"
                        class="action-btn"
                        @click="voltarLaudo"
                      >
                        <span class="material-icons">arrow_back</span>
                        Voltar
                      </v-btn>
                    </div>
                  </v-card-item>
                  
                  <v-divider />
                  
                  <v-card-text class="editor-content">
                    <tiptap-editor
                      v-model="conteudoLaudo"
                      :placeholder="'Digite o laudo médico aqui...'"
                      :editable="true"
                      :min-height="'400px'"
                      :max-height="'500px'"
                      @update:modelValue="onConteudoAlterado"
                      @character-count-change="onContadorCaracteres"
                    />
                  </v-card-text>
                  
                  <v-divider />
                  
                  <v-card-actions class="editor-footer">
                    <div class="editor-stats">
                      <v-chip
                        variant="outlined"
                        size="small"
                        class="status-chip"
                      >
                        <span class="material-icons icon-sm">text_fields</span>
                        {{ contadorCaracteres }} caracteres
                      </v-chip>
                      <v-chip 
                        variant="outlined" 
                        size="small"
                        :color="temAlteracoesNaoSalvas ? 'warning' : 'success'"
                        class="status-chip"
                      >
                        <span class="material-icons icon-sm">
                          {{ temAlteracoesNaoSalvas ? 'sync' : 'check_circle' }}
                        </span>
                        {{ temAlteracoesNaoSalvas ? 'Alterações não salvas' : 'Salvo' }}
                      </v-chip>
                    </div>
                  </v-card-actions>
                </v-card>
              </v-col>
              
              <v-col
                cols="12"
                md="4"
              >
                <!-- Painel Lateral -->
                <v-card
                  variant="outlined"
                  class="modern-card sidebar-panel"
                >
                  <v-card-item>
                    <div class="sidebar-section">
                      <h4 class="sidebar-title">
                        <span class="material-icons tab-icon">info</span>
                        Detalhes do Laudo
                      </h4>
                      <v-divider class="my-3" />
                      <div class="sidebar-content">
                        <div class="sidebar-item">
                          <strong>Exame:</strong> {{ selectedLaudo.nomeExame }}
                        </div>
                        <div class="sidebar-item">
                          <strong>Data:</strong> {{ formatDate(selectedLaudo.dataRegistro) }}
                        </div>
                        <div class="sidebar-item">
                          <strong>Status:</strong> 
                          <v-chip
                            :color="selectedLaudo.status === 'L' ? 'success' : 'warning'"
                            size="small"
                            class="status-chip"
                          >
                            {{ selectedLaudo.status === 'L' ? 'Liberado' : 'Pendente' }}
                          </v-chip>
                        </div>
                        <div class="sidebar-item">
                          <strong>Paciente:</strong> {{ selectedLaudo.nomePaciente }}
                        </div>
                      </div>
                    </div>

                    <!-- Observações do Técnico -->
                    <div
                      v-if="selectedLaudo.obsLaudoTec"
                      class="sidebar-section"
                    >
                      <h4 class="sidebar-title">
                        <span class="material-icons tab-icon">note</span>
                        Observações
                      </h4>
                      <v-divider class="my-2" />
                      <div class="sidebar-content">
                        <p class="sidebar-text">
                          {{ selectedLaudo.obsLaudoTec }}
                        </p>
                      </div>
                    </div>

                    <!-- Arquivos Disponíveis -->
                    <div class="sidebar-section">
                      <h4 class="sidebar-title">
                        <span class="material-icons tab-icon">attach_file</span>
                        Arquivos
                      </h4>
                      <v-divider class="my-2" />
                      <div class="sidebar-content">
                        <v-list
                          density="compact"
                          class="patient-list"
                        >
                          <v-list-item 
                            v-for="(file, index) in imagens" 
                            :key="index" 
                            class="patient-item file-item"
                            @click="abrirArquivo(file)"
                          >
                            <template #prepend>
                              <v-avatar
                                :color="getFileColor(file)"
                                size="32"
                                class="user-avatar"
                              >
                                <span class="material-icons white--text icon-sm">
                                  {{ getFileIcon(file) }}
                                </span>
                              </v-avatar>
                            </template>
                            <v-list-item-title class="text-caption">
                              Arquivo {{ index + 1 }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </div>
                    </div>

                    <!-- Modelos Rápidos -->
                    <div class="sidebar-section">
                      <h4 class="sidebar-title">
                        <span class="material-icons tab-icon">content_copy</span>
                        Modelos Rápidos
                      </h4>
                      <v-divider class="my-2" />
                      <div class="sidebar-content">
                        <v-btn 
                          v-for="modelo in modelosRapidos" 
                          :key="modelo.nome"
                          variant="outlined" 
                          size="small" 
                          block
                          class="mb-2 action-btn"
                          @click="aplicarModelo(modelo.conteudo)"
                        >
                          <span class="material-icons icon-sm">content_copy</span>
                          {{ modelo.nome }}
                        </v-btn>
                      </div>
                    </div>
                  </v-card-item>
                </v-card>
              </v-col>
            </v-row>
          </div>
          
          <div
            v-else
            class="empty-state"
          >
            <span class="material-icons empty-icon">edit_note</span>
            <div class="empty-text">
              Nenhum Laudo Selecionado
            </div>
          </div>
        </div>
      </v-window-item>
    </v-window>

    <!-- Floating Action Button para refresh -->
    <v-fab-transition>
      <v-btn
        color="primary"
        fab
        size="small"
        class="refresh-fab"
        :loading="loading"
        @click="recarregarLaudos"
      >
        <span class="material-icons">refresh</span>
      </v-btn>
    </v-fab-transition>
  </v-card>
</template>

<script>
import { ref, computed, onMounted, watch } from 'vue'
import medicoService from '../../services/medico.service'
import TiptapEditor from '../../components/medico/editor/tiptapEditor.vue'

export default {
  name: 'SistemaLaudosModerno',
  components: {
    TiptapEditor
  },
  
  setup() {
    // Estados reativos
    const user = ref(null)
    const activeTab = ref('laudos')
    const laudoTab = ref('abertos')
    const selectedLaudo = ref(null)
    const dadosPaciente = ref(null)
    const laudosLiberados = ref([])
    const laudosAbertos = ref([])
    const imagens = ref([])
    const buscaAtual = ref('')
    const conteudoLaudo = ref('')
    const contadorCaracteres = ref(0)
    const temAlteracoesNaoSalvas = ref(false)
    const salvando = ref(false)
    const loading = ref(false)

    // Modelos rápidos
    const modelosRapidos = ref([
      {
        nome: 'Laudo Normal',
        conteudo: '<p><strong>EXAME:</strong> [Nome do Exame]</p><p><strong>DESCRIÇÃO:</strong> Exame realizado dentro dos parâmetros de normalidade.</p><p><strong>CONCLUSÃO:</strong> Laudo normal.</p>'
      },
      {
        nome: 'Modelo Básico',
        conteudo: '<p><strong>EXAME:</strong> [Nome do Exame]</p><p><strong>DESCRIÇÃO:</strong> [Descrição dos achados]</p><p><strong>CONCLUSÃO:</strong> [Conclusão do exame]</p>'
      },
      {
        nome: 'Estrutura Detalhada',
        conteudo: '<h2>EXAME: [Nome do Exame]</h2><h3>DESCRIÇÃO:</h3><p>[Descrição detalhada dos achados]</p><h3>DISCUSSÃO:</h3><p>[Análise dos resultados]</p><h3>CONCLUSÃO:</h3><p>[Conclusão final]</p>'
      }
    ])

    // Computed
    const laudosLiberadosFiltrados = computed(() => {
      if (!buscaAtual.value) return laudosLiberados.value
      return laudosLiberados.value.filter(laudo =>
        laudo.nomePaciente.toLowerCase().includes(buscaAtual.value.toLowerCase()) ||
        laudo.apelidoExame.toLowerCase().includes(buscaAtual.value.toLowerCase())
      )
    })

    const laudosAbertosFiltrados = computed(() => {
      if (!buscaAtual.value) return laudosAbertos.value
      return laudosAbertos.value.filter(laudo =>
        laudo.nomePaciente.toLowerCase().includes(buscaAtual.value.toLowerCase()) ||
        laudo.apelidoExame.toLowerCase().includes(buscaAtual.value.toLowerCase())
      )
    })

    // Métodos
    const getIniciais = (nome) => {
      if (!nome) return '??'
      return nome.split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase()
        .substring(0, 2)
    }

    const abrirArquivo = (file) => {
      window.open(file, '_blank')
    }

    const getFileIcon = (file) => {
      if (file.toLowerCase().endsWith('.pdf')) return 'picture_as_pdf'
      if (file.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) return 'image'
      return 'insert_drive_file'
    }

    const getFileColor = (file) => {
      if (file.toLowerCase().endsWith('.pdf')) return 'rgb(var(--v-theme-error))'
      if (file.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) return 'rgb(var(--v-theme-success))'
      return 'rgb(var(--v-theme-info))'
    }

    const selectLaudo = (laudo) => {
      selectedLaudo.value = laudo
      activeTab.value = 'editor'
      conteudoLaudo.value = laudo.descricao || ''
      buscarLaudos(laudo.idExamesOS)
      retornarInformacoesPacienteOs(laudo.idOS)
      temAlteracoesNaoSalvas.value = false
    }

    const voltarLaudo = () => {
      if (temAlteracoesNaoSalvas.value) {
        if (!confirm('Existem alterações não salvas. Deseja realmente voltar?')) {
          return
        }
      }
      selectedLaudo.value = null
      dadosPaciente.value = null
      conteudoLaudo.value = ''
      activeTab.value = 'laudos'
      recarregarLaudos()
    }

    const salvarLaudo = async () => {
      if (!selectedLaudo.value) return
      
      salvando.value = true
      try {
        const payload = {
          idLaudo: selectedLaudo.value.idLaudo,
          descricao: conteudoLaudo.value
        }

        const response = await medicoService.medico.editarLaudo(payload)
        if (response.status === 200) {
          temAlteracoesNaoSalvas.value = false
          // Mostrar mensagem de sucesso
          console.log('Laudo salvo com sucesso!')
          recarregarLaudos()
        }
      } catch (error) {
        console.error('Erro ao salvar laudo:', error)
        // Mostrar mensagem de erro
      } finally {
        salvando.value = false
      }
    }

    const aplicarModelo = (conteudo) => {
      if (conteudoLaudo.value) {
        conteudoLaudo.value += '<br>' + conteudo
      } else {
        conteudoLaudo.value = conteudo
      }
      temAlteracoesNaoSalvas.value = true
    }

    const onConteudoAlterado = () => {
      temAlteracoesNaoSalvas.value = true
    }

    const onContadorCaracteres = (contador) => {
      contadorCaracteres.value = contador
    }

    const formatDate = (date) => {
      return new Date(date).toLocaleDateString('pt-BR')
    }

    const buscarLaudos = (idExamesOS) => {
      medicoService.medico.listarLaudosTecByIdsExamesOs([idExamesOS]).then((r) => {
        if (r.status === 200) {
          imagens.value = r.data.files || []
        }
      })
    }

    const listarLaudosTec = (status) => {
      loading.value = true
      medicoService.medico.listarLaudosTec(user.value.idPrestador, status).then((r) => {
        if (r.status === 200 && r.data.status) {
          if (status === 'X') {
            laudosAbertos.value = r.data.results || []
          } else {
            laudosLiberados.value = r.data.results || []
          }
        }
      }).finally(() => {
        loading.value = false
        if (status === 'X') {
          listarLaudosTec('L')
        }
      })
    }

    const retornarInformacoesPacienteOs = (idExamesOS) => {
      medicoService.medico.retornarInformacoesPacienteOs(idExamesOS).then((r) => {
        if (r.status === 200) {
          dadosPaciente.value = r.data
        }
      })
    }

    const recarregarLaudos = () => {
      listarLaudosTec('X')
      if (selectedLaudo.value) {
        buscarLaudos(selectedLaudo.value.idExamesOS)
      }
    }

    // Watchers
    watch(selectedLaudo, (newVal) => {
      if (newVal) {
        retornarInformacoesPacienteOs(newVal.idOS)
      }
    })

    // Lifecycle
    onMounted(() => {
      user.value = JSON.parse(localStorage.getItem('usuario') || '{}')
      listarLaudosTec('X')
    })

    return {
      user,
      activeTab,
      laudoTab,
      selectedLaudo,
      dadosPaciente,
      laudosLiberados,
      laudosAbertos,
      imagens,
      buscaAtual,
      conteudoLaudo,
      contadorCaracteres,
      temAlteracoesNaoSalvas,
      salvando,
      loading,
      modelosRapidos,
      laudosLiberadosFiltrados,
      laudosAbertosFiltrados,
      getIniciais,
      abrirArquivo,
      getFileIcon,
      getFileColor,
      selectLaudo,
      voltarLaudo,
      salvarLaudo,
      aplicarModelo,
      onConteudoAlterado,
      onContadorCaracteres,
      formatDate,
      recarregarLaudos
    }
  }
}
</script>

<style scoped>
.laudos-system {
  border-radius: 16px;
  overflow: hidden;
  background: rgb(var(--v-theme-surface));
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 700px;
}

/* Header do Paciente */
.patient-header {
  padding: 16px;
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.05) 0%, rgba(var(--v-theme-secondary), 0.05) 100%);
}

.header-card {
  border-radius: 12px;
  border: 1px solid rgba(var(--v-theme-primary), 0.1);
}

.patient-identity {
  display: flex;
  align-items: center;
  gap: 16px;
}

.patient-info {
  flex: 1;
}

.patient-name {
  font-size: 1.5rem;
  font-weight: 600;
  color: rgb(var(--v-theme-primary));
  margin-bottom: 8px;
}

.info-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.info-icon {
  font-size: 20px;
  color: rgb(var(--v-theme-primary));
  flex-shrink: 0;
}

.info-content {
  flex: 1;
}

.info-label {
  font-size: 0.875rem;
  color: rgba(var(--v-theme-on-surface), 0.6);
  margin-bottom: 2px;
}

.info-value {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(var(--v-theme-on-surface), 0.8);
}

/* Tabs Principais */
.main-tabs {
  background: rgb(var(--v-theme-surface));
  min-height: 64px;
  flex-shrink: 0;
  margin-top: 16px; /* Espaço do topo */
  border-radius: 12px;
  border: 1px solid rgba(var(--v-theme-on-surface), 0.1);
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.1); /* Separador visual */
}

.main-tabs :deep(.v-tab) {
  color: rgb(var(--v-theme-primary)) !important; /* Cor do texto das abas */
  opacity: 0.7;
  transition: all 0.3s ease;
  min-width: 180px !important;
  max-width: 220px !important;
  flex: 1 1 auto;
  border-radius: 8px; /* Arredondar as bordas das abas */
  margin: 0 4px; /* Pequeno espaçamento entre as abas */
}

.main-tabs :deep(.v-tab--selected) {
  opacity: 1;
  background: rgba(var(--v-theme-primary), 0.1); /* Fundo suave para a aba selecionada */
  color: rgb(var(--v-theme-primary)) !important; /* Cor do texto da aba selecionada */
  box-shadow: 0 1px 4px rgba(var(--v-theme-primary), 0.08); /* Sombra sutil para destaque */
}

.wide-tab {
  padding: 12px 20px !important;
  position: relative;
  min-height: 64px;
  border-radius: 0;
}

.wide-tab-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  justify-content: flex-start;
}

.tab-text-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1;
}

.icon-badge-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tab-icon {
  font-size: 28px !important;
  opacity: 0.9;
}

.icon-badge {
  position: absolute;
  top: -6px;
  right: -6px;
}

.icon-badge :deep(.v-badge__badge) {
  font-size: 11px;
  font-weight: 700;
  min-width: 20px;
  height: 20px;
  border: 2px solid rgb(var(--v-theme-surface));
  background: rgb(var(--v-theme-error));
}

.tab-label {
  font-size: 14px !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: left;
  color: rgb(var(--v-theme-on-surface));
}

.priority-indicator {
  background: rgb(var(--v-theme-warning));
  color: rgb(var(--v-theme-on-warning));
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  animation: pulse 2s infinite;
  white-space: nowrap;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Conteúdo Principal */
.main-window {
  background: rgb(var(--v-theme-background));
  flex: 1;
  min-height: 500px;
  display: flex;
  flex-direction: column;
}

.tab-content-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Controles */
.controls-section {
  padding: 16px;
  background: rgb(var(--v-theme-surface));
  display: flex;
  gap: 16px;
  align-items: center;
  flex-shrink: 0;
}

.sub-tabs {
  flex: 1;
  background: transparent !important;
}

.sub-tabs :deep(.v-tab) {
  color: rgb(var(--v-theme-primary)) !important;
  font-weight: 500;
  min-width: 160px;
}

.search-field {
  min-width: 300px;
  flex-shrink: 0;
  border-radius: 12px;
}

.search-field :deep(.v-input__slot) {
  border-radius: 12px !important;
  background: rgb(var(--v-theme-surface));
}

/* Conteúdo */
.content-area {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
}

.patient-list.tall-list {
  max-height: 500px !important;
  min-height: 450px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  padding-right: 4px;
}

.laudo-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  border-radius: 12px;
}

.laudo-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.15);
  border-color: rgba(var(--v-theme-primary), 0.2);
}

.laudo-card.selected {
  border-color: rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.04);
}

.laudo-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.laudo-content {
  flex: 1;
}

.laudo-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
}

.laudo-title {
  font-size: 16px;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin: 0;
}

.status-chip {
  font-weight: 600;
}

.laudo-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: rgba(var(--v-theme-on-surface), 0.7);
}

.detail-icon {
  font-size: 16px;
  color: rgba(var(--v-theme-on-surface), 0.5);
}

/* Editor */
.editor-container {
  padding: 16px;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.editor-card {
  border-radius: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.editor-header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: rgba(var(--v-theme-primary), 0.05);
  flex-shrink: 0;
}

.editor-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: rgb(var(--v-theme-primary));
  display: flex;
  align-items: center;
}

.editor-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-1px);
}

.editor-content {
  padding: 0;
  min-height: 400px;
  flex: 1;
}

.editor-footer {
  padding: 12px 20px;
  background: rgb(var(--v-theme-background));
  flex-shrink: 0;
}

.editor-stats {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Sidebar */
.sidebar-panel {
  border-radius: 16px;
  height: 100%;
}

.sidebar-section {
  margin-bottom: 20px;
}

.sidebar-section:last-child {
  margin-bottom: 0;
}

.sidebar-title {
  font-size: 1rem;
  font-weight: 600;
  color: rgb(var(--v-theme-primary));
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.sidebar-content {
  padding: 4px 0;
}

.sidebar-item {
  padding: 8px 0;
  font-size: 14px;
  color: rgb(var(--v-theme-on-surface));
  line-height: 1.5;
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
}

.sidebar-item:last-child {
  border-bottom: none;
}

.sidebar-text {
  font-size: 14px;
  line-height: 1.5;
  color: rgba(var(--v-theme-on-surface), 0.7);
  margin: 0;
}

.file-item {
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 4px;
  transition: background-color 0.2s ease;
}

.file-item:hover {
  background: rgba(var(--v-theme-on-surface), 0.04);
  transform: translateX(4px);
}

/* Empty States */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  flex: 1;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.4;
  color: rgb(var(--v-theme-disabled));
}

.empty-text {
  color: rgba(var(--v-theme-on-surface), 0.6);
  font-size: 14px;
  font-weight: 500;
}

/* FAB */
.refresh-fab {
  position: absolute;
  bottom: 24px;
  right: 24px;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.15);
  background: rgb(var(--v-theme-primary)) !important;
  color: rgb(var(--v-theme-on-primary)) !important;
}

.refresh-fab:hover {
  background: rgb(var(--v-theme-secondary)) !important;
  transform: scale(1.05);
}

/* Material Icons base styles */
.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
}

.icon-sm {
  font-size: 16px;
}

/* Scrollbar personalizada */
.content-area::-webkit-scrollbar,
.patient-list::-webkit-scrollbar {
  width: 8px;
}

.content-area::-webkit-scrollbar-track,
.patient-list::-webkit-scrollbar-track {
  background: rgba(var(--v-theme-on-surface), 0.04);
  border-radius: 4px;
}

.content-area::-webkit-scrollbar-thumb,
.patient-list::-webkit-scrollbar-thumb {
  background: rgba(var(--v-theme-primary), 0.5);
  border-radius: 4px;
}

.content-area::-webkit-scrollbar-thumb:hover,
.patient-list::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-theme-primary), 0.7);
}

/* Responsividade */
@media (max-width: 1200px) {
  .main-tabs :deep(.v-tab) {
    min-width: 160px !important;
    max-width: 180px !important;
  }
  
  .wide-tab {
    padding: 14px 16px !important;
  }
  
  .tab-icon {
    font-size: 24px !important;
  }
  
  .tab-label {
    font-size: 13px !important;
  }
  
  .patient-list.tall-list {
    max-height: 450px !important;
    min-height: 400px;
  }
}

@media (max-width: 960px) {
  .main-tabs :deep(.v-tab) {
    min-width: 140px !important;
    max-width: 160px !important;
  }
  
  .wide-tab-content {
    gap: 8px;
  }
  
  .tab-icon {
    font-size: 22px !important;
  }
  
  .tab-label {
    font-size: 12px !important;
  }
  
  .controls-section {
    flex-direction: column;
    align-items: stretch;
  }
  
  .search-field {
    min-width: auto;
  }
  
  .patient-list.tall-list {
    max-height: 400px !important;
    min-height: 350px;
  }
}

@media (max-width: 768px) {
  .main-tabs {
    min-height: 80px;
  }
  
  .main-tabs :deep(.v-tab) {
    min-width: 120px !important;
    max-width: 140px !important;
  }
  
  .wide-tab {
    padding: 12px 8px !important;
    min-height: 80px;
  }
  
  .wide-tab-content {
    flex-direction: column;
    gap: 4px;
  }
  
  .tab-text-content {
    align-items: center;
  }
  
  .tab-label {
    text-align: center;
    font-size: 11px !important;
  }
  
  .tab-icon {
    font-size: 20px !important;
  }
  
  .icon-badge :deep(.v-badge__badge) {
    font-size: 9px;
    min-width: 16px;
    height: 16px;
  }
  
  .patient-list.tall-list {
    max-height: 350px !important;
    min-height: 300px;
  }
  
  .laudos-system {
    min-height: 600px;
  }
  
  .editor-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  
  .editor-actions {
    width: 100%;
    justify-content: flex-end;
  }
  
  .patient-identity {
    flex-direction: column;
    text-align: center;
  }
  
  .refresh-fab {
    bottom: 16px;
    right: 16px;
  }
}

/* Garantir que o layout flex funcione corretamente */
:deep(.v-window__container) {
  height: 100%;
  flex: 1;
}

:deep(.v-window-item) {
  height: 100%;
}
</style>
